import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingBag, Columns3 } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";

export default function PageHeader({
  selectedFamily,
  cartCount,
  pinCount = 0,
  onBack,
  onToggleSummary,
  onToggleTray,
}) {
  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-[var(--mp-line)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16 lg:h-20">
        <div className="flex items-center gap-4">
          {selectedFamily ? (
            <button onClick={onBack} className="p-2" data-testid="colours-back-btn">
              <ArrowLeft className="w-5 h-5" style={{ color: "var(--mp-text-strong)" }} />
            </button>
          ) : (
            <Link to="/" className="p-2">
              <ArrowLeft className="w-5 h-5" style={{ color: "var(--mp-text-strong)" }} />
            </Link>
          )}
          <div>
            <h1
              className="text-lg font-medium"
              style={{ fontFamily: "'Cormorant Garamond', serif", color: "var(--mp-text)" }}
            >
              {selectedFamily ? selectedFamily.name : "Colour Catalogue"}
            </h1>
            {selectedFamily && (
              <p
                className="text-[11px]"
                style={{ fontFamily: "'Manrope', sans-serif", color: "var(--mp-muted)" }}
              >
                {selectedFamily.colours.length} shades available
              </p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          {pinCount > 0 && (
            <button
              onClick={onToggleTray}
              className="flex items-center gap-2 px-3 py-1.5 rounded-sm border"
              style={{ borderColor: "var(--mp-copper)" }}
              data-testid="compare-toggle-btn"
            >
              <Columns3 className="w-4 h-4" style={{ color: "var(--mp-copper)" }} />
              <span className="text-xs font-semibold" style={{ color: "var(--mp-copper)" }}>
                {pinCount}
              </span>
            </button>
          )}
          {cartCount > 0 && (
            <button
              onClick={onToggleSummary}
              className="flex items-center gap-2 px-3 py-1.5 rounded-sm border border-[var(--mp-solid)]"
              data-testid="cart-toggle-btn"
            >
              <ShoppingBag className="w-4 h-4" style={{ color: "var(--mp-text-strong)" }} />
              <span className="text-xs font-semibold" style={{ color: "var(--mp-text-strong)" }}>
                {cartCount}
              </span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
